import i18next from "i18next";
import type { i18n } from "i18next";
import { initReactI18next } from "react-i18next";

import type { AppFeatureDefinition, Language } from "@nasam/kernel";
import {
  getRegisteredI18nModules,
  loadModulesI18n,
  registerInstanceModule,
} from "./loadModuleI18n";
import { I18N_NAMESPACES, i18nResources } from "./resources";

export {
  getRegisteredI18nModules,
  loadModuleI18n,
  loadModulesI18n,
} from "./loadModuleI18n";

export async function createAppI18n(
  language: Language,
  modules?: readonly AppFeatureDefinition[],
): Promise<i18n> {
  const instance = i18next.createInstance();
  await instance.use(initReactI18next).init({
    resources: i18nResources,
    lng: language,
    fallbackLng: "en",
    defaultNS: "common",
    ns: [...I18N_NAMESPACES],
    interpolation: { escapeValue: false },
  });

  if (modules && modules.length > 0) {
    await loadModulesI18n(instance, modules, language);
  }

  return instance;
}

export async function changeAppLanguage(
  instance: i18n,
  language: Language,
  modules?: readonly AppFeatureDefinition[],
): Promise<void> {
  const allModulesMap = new Map<string, AppFeatureDefinition>();

  for (const module of getRegisteredI18nModules(instance)) {
    allModulesMap.set(module.id, module);
  }

  if (modules) {
    for (const module of modules) {
      registerInstanceModule(instance, module);
      allModulesMap.set(module.id, module);
    }
  }

  const targetModules = Array.from(allModulesMap.values());
  if (targetModules.length > 0) {
    await loadModulesI18n(instance, targetModules, language);
  }

  await instance.changeLanguage(language);

  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  }
}
